class InfiniteScrollProducts extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('#product-grid');
    this.paginationWrapper = this.querySelector('.pagination-wrapper');
    this.loading = false;
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'infinite-scroll-sentinel';
    this.sentinel.setAttribute('aria-hidden', 'true');
    this.sentinel.innerHTML = '&nbsp;';
    this.observer = null;
  }

  connectedCallback() {
    if (!this.grid || !this.paginationWrapper) return;
    this.paginationWrapper.classList.add('infinite-scroll-hidden');
    this.paginationWrapper.insertAdjacentElement('afterend', this.sentinel);
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      rootMargin: '800px 0px 800px 0px',
    });
    this.observer.observe(this.sentinel);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  getNextUrl() {
    if (!this.paginationWrapper) return null;
    const nextLink = this.paginationWrapper.querySelector('.pagination__item--prev');
    return nextLink ? nextLink.getAttribute('href') : null;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loading) {
        this.loadNextPage();
      }
    });
  }

  showLoading() {
    this.sentinel.classList.add('infinite-scroll-loading');
    this.sentinel.setAttribute('aria-busy', 'true');
  }

  hideLoading() {
    this.sentinel.classList.remove('infinite-scroll-loading');
    this.sentinel.removeAttribute('aria-busy');
  }

  destroy() {
    if (this.observer) this.observer.disconnect();
    this.sentinel.remove();
  }

  async loadNextPage() {
    const nextUrl = this.getNextUrl();
    if (!nextUrl) {
      this.destroy();
      return;
    }

    this.loading = true;
    this.showLoading();

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Infinite scroll fetch failed: ' + response.status);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newGrid = doc.getElementById('product-grid');
      const newPaginationWrapper = doc.querySelector('.pagination-wrapper');

      if (newGrid) {
        const fragment = document.createDocumentFragment();
        Array.from(newGrid.children).forEach((item) => fragment.appendChild(item));
        this.grid.appendChild(fragment);

        if (window.Shopify && window.Shopify.designMode !== true) {
          document.dispatchEvent(new CustomEvent('infinite-scroll:products-appended'));
        }
      }

      if (newPaginationWrapper) {
        newPaginationWrapper.classList.add('infinite-scroll-hidden');
        this.paginationWrapper.replaceWith(newPaginationWrapper);
        this.paginationWrapper = newPaginationWrapper;
      } else {
        this.destroy();
      }
    } catch (error) {
      console.error(error);
      this.destroy();
    } finally {
      this.loading = false;
      this.hideLoading();
    }
  }
}

if (!customElements.get('infinite-scroll-products')) {
  customElements.define('infinite-scroll-products', InfiniteScrollProducts);
}
